import { createFileRoute } from "@tanstack/react-router";
import { AuthFlow } from "@/components/auth-flows";

export const Route = createFileRoute("/forgot-password")({
  head: () => ({
    meta: [
      { title: "Xamseen — Reset your password" },
      { name: "description", content: "Request a secure link to reset the password on your Xamseen account." },
      { property: "og:title", content: "Reset your Xamseen password" },
      { property: "og:description", content: "Request a secure link to reset the password on your Xamseen account." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: () => <AuthFlow initialMode="forgot" />,
});
